import { render, staticRenderFns } from "./ColorSchemePicker.vue?vue&type=template&id=1bda94b0&"
import script from "./ColorSchemePicker.vue?vue&type=script&lang=ts&"
export * from "./ColorSchemePicker.vue?vue&type=script&lang=ts&"
import style0 from "./ColorSchemePicker.vue?vue&type=style&index=0&id=1bda94b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports